module.exports = __webpack_public_path__ + "static/media/triclorogranulado.10f80127.pdf";